// extracted by mini-css-extract-plugin
export var endQuote = "reviews-module--endQuote--litik";
export var startQuote = "reviews-module--startQuote--EAEoa";